import {RootState} from '../../../store';

const key = 'subscriptions';

// FNP-964: the `records` sub-reducer is gone - records live in React Query
// (hooks/useSubscriptions.ts, useInfiniteQuery). Redux keeps SELECTION (the
// checkbox set, the platform standard per FNP-951) and VISIBILITY.
//
// The old selectors derived items/visibleItems/visibleCount/totalPages from a
// slice nothing populated. Their only two consumers were an unmounted
// MultiSelect and a select-all helper nothing called, so they are removed
// rather than rewired - see the ticket for the observed (dormant) symptom.

export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};

export const visibilityStateSelector = (state: RootState) => {
    return state[key].visibility;
};
